<template>
  <Loader :loading="httpSend">
    <div v-show="!list_solicitacoes.length || list_solicitacoes.length < 1" role="alert" aria-live="polite"
         aria-atomic="true" class="alert alert-primary text-center">
      Sem solicitações
    </div>
    <div v-show="list_solicitacoes.length && list_solicitacoes.length > 0" class="table-responsive mb-0">
      <table class="table table-centered table-nowrap">
        <thead class="thead-light">
        <tr>
          <th>Protocolo</th>
          <th>Tipo</th>
          <th>Pessoa</th>
          <th>CPF/CNPJ</th>
          <th>Data</th>
          <th>Status</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="s in list_solicitacoes" :key="s.tps_codigo">
          <td>
            <span class="text-body font-weight-bold" v-if="!s.ceh_protocolo">-</span>
            <span class="text-body font-weight-bold" v-else>{{ s.ceh_protocolo }}</span>
          </td>
          <td>{{ s.tps_tipo | tipoPessoaTabNumero }}</td>
          <td>{{ s.tps_razao_social_nome }}</td>
          <td>
            <span v-if="s.tps_cpf_cnpj.length < 12">{{ s.tps_cpf_cnpj | VMask('###.###.###-##') }}</span>
            <span v-else>{{ s.tps_cpf_cnpj| VMask('##.###.###/####-##') }}</span>
          </td>
          <td>
            <span v-if="!s.ceh_data">-</span>
            <span class="text-body font-weight-bold" v-else>{{ s.ceh_data | formatDate }}</span>
          </td>
          <td>
            <span v-if="!s.chm_status" class="badge badge-soft-dark font-size-12">Rascunho</span>
            <span v-if="s.chm_status === '1'" class="badge badge-soft-primary font-size-12">Solicitada</span>
            <span v-if="s.chm_status === '2'" class="badge badge-soft-info font-size-12">Em Andamento</span>
            <span v-if="s.chm_status === '3'" class="badge badge-soft-warning font-size-12">Pendente</span>
            <span v-if="s.chm_status === '4'" class="badge badge-soft-danger font-size-12">Rejeitada</span>
            <span v-if="s.chm_status === '9'" class="badge badge-soft-success font-size-12">Aprovada</span>
          </td>
          <td class="text-right">
            <button type="button" @click="detalhe(s)" class="btn btn-sm btn-outline-dark mr-2">
              Visualizar
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </Loader>
</template>
<script>
import Loader from "@/components/widgets/loader";
import {listLiberacao} from "@/api/admin/liberacao/pessoa";

export default {
  components: {
    Loader,
  },
  data() {
    return {
      list_solicitacoes: [],
      httpSend: false,
    };
  },
  created() {
    this.getSolicitacao();
  },
  methods: {
    getSolicitacao() {
      this.httpSend = true;
      listLiberacao().then(result => {
        this.list_solicitacoes = result.dados
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    detalhe(solicitacao) {
      this.$router.push({
        name: 'admin-liberacao-pessoa-detalhe',
        params: {tps_hash: solicitacao.tps_hash}
      })
    },
  }
};
</script>

